/**
 * 커뮤니티 글 목록 컴포넌트
 * 글 카드 형태로 목록을 표시하고 클릭 이벤트를 처리
 */

import React from 'react';
import { getRelativeTime } from '../../api/communityApi';
import './PostList.css';

const PostItem = ({ post, onPostClick, loading }) => {
  const handleClick = () => {
    if (!loading) {
      onPostClick(post.id);
    }
  };

  return (
    <div 
      className={`post-item ${loading ? 'loading' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {/* 글 헤더 */}
      <div className="post-header">
        <h3 className="post-title">
          {post.title}
        </h3>
        <div className="post-meta">
          <span className="author">
            {post.author_name || '익명'}
          </span>
          <span className="separator">•</span>
          <span className="time">
            {getRelativeTime(post.created_at)}
          </span>
        </div>
      </div>

      {/* 글 내용 미리보기 */}
      <div className="post-content">
        <p className="content-preview">
          {post.content}
        </p>
      </div>

      {/* 글 통계 */}
      <div className="post-stats">
        <div className="stat-item">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <span className="count">{post.view_count || 0}</span>
        </div>
        <div className="stat-item">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          </svg>
          <span className="count">{post.comment_count || 0}</span>
        </div>
      </div>
    </div>
  );
};

const PostList = ({ posts, onPostClick, loading = false }) => {
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className={`post-list ${loading ? 'refreshing' : ''}`}>
      {posts.map((post) => (
        <PostItem
          key={post.id}
          post={post}
          onPostClick={onPostClick}
          loading={loading}
        />
      ))}
    </div>
  );
};

export default PostList; 